import { useEffect } from "react";

import { Block, Range } from "../types";
import { smoothCenterBlock } from "../util";

export const useScrollToActivePageBlock = (
  scrollRef: HTMLElement | null,
  selectedBlock: Block | undefined,
  scale: number,
  pageRanges: ReadonlyArray<Range>,
) => {
  useEffect(() => {
    if (!scrollRef || !selectedBlock) {
      return;
    }
    const top = selectedBlock.minY * scale + pageRanges[selectedBlock.page].start;
    const height = (selectedBlock.maxY - selectedBlock.minY) * scale;
    smoothCenterBlock(scrollRef, top, height);
  }, [scrollRef, selectedBlock]);
};
